import laptop from '../assets/category_products/laptop.webp'
import pc from '../assets/category_products/pc.webp'
import manhinh from '../assets/category_products/manhinh.webp'
import mainboard from '../assets/category_products/mainboard.webp'
import cpu from '../assets/category_products/cpu.webp'
import vga from '../assets/category_products/vga.webp'
import ram from '../assets/category_products/ram.webp'
import hardware from '../assets/category_products/hardware.webp'
import casePC from '../assets/category_products/case.webp'
import tannhiet from '../assets/category_products/tannhiet.webp'
import nguon from '../assets/category_products/nguon.webp'
import banphim from '../assets/category_products/banphim.webp'
import chuot from '../assets/category_products/chuot.jpg'
import ghe from '../assets/category_products/ghe.webp'
import tainghe from '../assets/category_products/tainghe.webp'
import loa from '../assets/category_products/loa.webp'
import consoleImg from '../assets/category_products/console.webp'
import phukien from '../assets/category_products/phukien.webp'
import thietbivp from '../assets/category_products/thietbivp.webp'
import apple from '../assets/category_products/apple.webp'


export const categoryProducts = [
    { 
        src: laptop,
        name: 'Laptop'
    },
    { 
        src: pc,
        name: 'PC'
    },
    { 
        src: manhinh,
        name: 'Màn hình'
    },
    { 
        src: mainboard,
        name: 'Mainboard'
    },
    { 
        src: cpu,
        name: 'CPU'
    },
    { 
        src: vga,
        name: 'VGA'
    },
    { 
        src: ram,
        name: 'Ram'
    },
    { 
        src: hardware,
        name: 'ổ cứng'
    },
    { 
        src: casePC,
        name: 'Case'
    },
    { 
        src: tannhiet,
        name: 'Tản nhiệt'
    },
    { 
        src: nguon,
        name: 'Nguồn'
    },
    { 
        src: banphim,
        name: 'Bàn phím'
    },
    { 
        src: chuot,
        name: 'Chuột'
    },
    { 
        src: ghe,
        name: 'Ghế'
    },
    
    { 
        src: tainghe,
        name: 'Tai nghe'
    },
    
    { 
        src: loa,
        name: 'Loa'
    },
    
    { 
        src: consoleImg,
        name: 'Console'
    },
    
    { 
        src: phukien,
        name: 'Phụ kiện'
    },
    
    { 
        src: thietbivp,
        name: 'Thiết bị VP'
    },
    { 
        src: apple,
        name: 'Apple'
    },
    
]